import React from 'react';
import { ChatPanel } from './ChatPanel';

interface TaskChatProps {
  taskId: string;
  taskName: string;
  taskStatus: string;
  streamId: string;
  streamName: string;
  agentName?: string;
  onClose: () => void;
  onShowDetails?: () => void;
  onShowContext?: () => void;
}

/**
 * Task-level chat component.
 * Thin wrapper around ChatPanel with task scope.
 */
export function TaskChat({
  taskId,
  taskName,
  taskStatus,
  streamId,
  streamName,
  agentName,
  onClose,
  onShowDetails,
  onShowContext,
}: TaskChatProps) {
  return (
    <ChatPanel
      scope="task"
      variant="inline"
      streamId={streamId}
      streamName={streamName}
      nodeId={taskId}
      taskName={taskName}
      taskStatus={taskStatus}
      agentName={agentName}
      onClose={onClose}
      onShowDetails={onShowDetails}
      onShowContext={onShowContext}
    />
  );
}
